export default __webpack_public_path__ + "static/media/RedHatDisplay-Medium.55973a9d.ttf";